module.exports = __webpack_public_path__ + "img/spin_btn.182b1c18.png";